
function getProdLatest(_tag){
   
  console.log("Hello Rude!");
  var q =  `{shop{name}}`;
  const t = _tag;
  let tag = `query: "tag:'obj'" `;  
  const GET_PRODUCTS_BY_TAG =  `{ 
    products( ${tag}, first:10 ) { 
      edges {
        node {
          id
          title
          tags  
          handle
          featuredImage {
            id
            url
          }
          
        }
      }
    }
  }`;
   
  $.ajax({
    type:"POST",
    url: '/api/2023-04/graphql.json',
    dataType: 'json',
    headers: {"X-Shopify-Storefront-Access-Token": "e332719872a16b55007a45f84ac01a43"},
    data: JSON.stringify({"query":GET_PRODUCTS_BY_TAG }),
    contentType: 'application/json',
    success: function(data){
        console.log("<< data.products >>");
        console.log(data.data.products.edges);
        var totalProd = data.data.products.edges;
        
       // $("#MainContent").find("#artist_select").text(_tag);
        // var result= $("#MainContent").find("#custom_slide");
        // result.empty();
        // for(var i=0; i<totalProd.length; i++){
        //    result.append(renderResultProducts(
        //      totalProd[i].node.title,
        //      totalProd[i].node.featuredImage.url,
        //      totalProd[i].node.priceRange.maxVariantPrice.amount,
        //      totalProd[i].node.handle
        //      ),            
        //   );
        // }


   console.log( "TBL_SLIDE Javascript" ); 
    // $('.custom_slide').slick({
    //    slidesToShow: 4,
    //    slidesToScroll: 1,
    //   // autoplay: true,
    //   // autoplaySpeed: 2000,
    //    arrows: true,
    //   //fade: true, 
    //   // centerPadding: '60px',
    //    responsive: [
    //     {
    //       breakpoint: 1024,
    //       settings: {
    //         slidesToShow: 4,
    //         slidesToScroll: 1,
    //         infinite: true,
    //       }
    //     },
    //     {
    //       breakpoint: 600, 
    //       settings: {
    //         slidesToShow: 2,
    //         slidesToScroll: 2 
    //       }
    //     },
    //     {
    //       breakpoint: 480, 
    //       settings: {
    //         slidesToShow: 1,
    //         slidesToScroll: 1 
    //       }
    //     } 
    //   ]
    // });
    },
    error: function(data){
        console.log(data);
        console.log('errors');
    }
  });
}

//RENDER CARD
function renderResultProducts(title, imagesUrl, price, linkProduct){
   return ` 
   
   <div class="relative overflow-hidden">
      <div data-color-scheme="primary" data-image-id="" class="responsive-image-wrapper relative overflow-hidden w-full my-0 mx-auto " style="height: 0; padding-top: 100.0%;">
         <img src="${imagesUrl}" class="responsive-image block absolute top-0 left-0 w-full h-full  transition-opacity duration-200 ease-in-out w-full max-w-full h-auto transition-transform transform group-hover:scale-110 lazyautosizes lazyloaded"   data-aspectratio="1.0" data-sizes="auto" tabindex="-1" alt="${title}" data-srcset="${imagesUrl}">
         <div class="responsive-image-placeholder bg-scheme-text absolute top-0 left-0 right-0 bottom-0"></div>
         <noscript>
            <div class="absolute top-0 left-0 w-full h-full">
               <img class=" " src="${imagesUrl}">
            </div>
         </noscript>
      </div>
   </div>
   <div class="text-base">
      <a href="/products/${linkProduct}" class="absolute top-0 left-0 w-full h-full z-20 block">
      <span class="visually-hidden">${title}</span>
      </a>
      <div class="text-scheme-text mt-6 mb-1 break-words" aria-hidden="true">
         <p class="product-grid-title">${title}</p>
      </div>
      <p class="price m0 mt-2">
        Euro ${price}0
      </p>
   </div>
   </div>
 `; 
}

jQuery(document).ready(function() {  
    //ajax call get products by tag [latest]
    var dataTag = $("#custom_slide").attr("data-tag");
     
     getProdLatest('latest');
});  


  document.addEventListener("DOMContentLoaded", function () {
    // Seleziona il menu <nav>
    const nav = document.querySelector('nav[aria-label="Primary"]');

    if (!nav) return;

    // Seleziona solo gli elementi all'interno del nav con classe 'font-secondary'
    const secondaryItems = nav.querySelectorAll('.font-secondary');

    secondaryItems.forEach(item => {
      item.style.textAlign = 'left';
    });
  });

